import { render, staticRenderFns } from "./supplier-apply.vue?vue&type=template&id=4e16de86&scoped=true"
import script from "./supplier-apply.vue?vue&type=script&lang=js"
export * from "./supplier-apply.vue?vue&type=script&lang=js"
import style0 from "./supplier-apply.vue?vue&type=style&index=0&id=4e16de86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e16de86",
  null
  
)

export default component.exports